module.exports = __webpack_public_path__ + "img/linkedin.7ee26385.svg";